<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39.27 26.38"
    style="enable-background: new 0 0 39.27 26.38"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <g>
        <path
          class="text-gray-300"
          d="M36.16,13.38H3.11c-1.11,0-2.02,0.9-2.02,2.02v7.63h37.08V15.4C38.18,14.28,37.27,13.38,36.16,13.38z"
        />
      </g>
      <g>
        <path
          class="text-gray-300"
          d="M35.92,13.38V3.59c0-1.43-0.78-2.59-1.74-2.59H5.66C4.7,1,3.92,2.16,3.92,3.59v9.79"
        />
      </g>
    </g>
    <path
      class="bg-gray-500"
      d="M39.18,15.4c0-1.4-0.96-2.57-2.26-2.91v-8.9c0-2.01-1.2-3.59-2.74-3.59H5.66C4.12,0,2.92,1.58,2.92,3.59v8.81
	c-1.57,0.1-2.82,1.4-2.82,3v8.63h2.82v2.4h2v-2.4h30v2.4h2v-2.4h2.26V15.4z M5.66,2h28.52c0.26,0,0.74,0.6,0.74,1.59v8.79h-2.33
	V6.57c0-1.13-0.92-2.05-2.05-2.05h-8.06c-1.13,0-2.05,0.92-2.05,2.05v5.81h-1.39V6.57c0-1.13-0.92-2.05-2.05-2.05H8.92
	c-1.13,0-2.05,0.92-2.05,2.05v5.81H4.92V3.59C4.92,2.6,5.4,2,5.66,2z M30.59,12.38h-8.16l0.05-5.86l8.11,0.05V12.38z M17.04,12.38
	H8.88l0.05-5.86l8.11,0.05V12.38z M37.18,22.02H2.09V15.4c0-0.56,0.46-1.02,1.02-1.02h33.05c0.56,0,1.02,0.46,1.02,1.02V22.02z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
